<template>
  <footer class="vue-footer">
    <div class="vue-footer-content">
      <div class="footer-logo">
        <img src="/favicon.ico" alt="ISIS da Vinci-Carli-Sandrinelli" class="logo-icon" />
      </div>

      <div class="footer-section">
        <h4>Sede di Via Diaz</h4>
        <p><strong>Istituto "G.R. Carli"</strong></p>
        <p>Via A. Diaz, 20<br>34124 – Trieste<br>Tel: 040 300744</p>
      </div>

      <div class="footer-section">
        <h4>Email – Codici Istituto</h4>
        <p>
          <a href="mailto:tsis001002@istruzione.it">tsis001002@istruzione.it</a><br>
          <a href="mailto:tsis001002@pec.istruzione.it">tsis001002@pec.istruzione.it</a> (PEC)
        </p>
        <p>
          <strong>Codice Fiscale:</strong> 80020660322<br>
          <strong>Codice Meccanografico:</strong> TSIS001002
        </p>
      </div>

      <div class="footer-section">
        <p><strong>ISIS da Vinci-Carli-Sandrinelli © 2026 Tutti i diritti riservati</strong></p>
        <p>Sviluppato da <strong>Nikita Dervishov</strong></p>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.vue-footer {
  background-color: #0a0b0d;
  border-top: 1px solid #333;
  margin-top: 100px;
  padding: 40px 20px;
  color: #999;
  font-size: 13px;
  line-height: 1.8;
}

.vue-footer-content {
  max-width: 940px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: auto 1fr 1fr 1fr;
  gap: 40px;
  align-items: start;
}

.footer-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 70px;
}

.logo-icon {
  width: 56px;
  height: 56px;
  opacity: 0.9;
  transition: opacity 0.3s ease;
}

.logo-icon:hover {
  opacity: 1;
}

.footer-section {
  text-align: left;
}

.footer-section h4 {
  color: #fff;
  font-size: 14px;
  margin: 0 0 15px 0;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.footer-section p {
  margin: 10px 0;
  color: #aaa;
}

.footer-section a {
  color: #6db3f2;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-section a:hover {
  color: #fff;
  text-decoration: underline;
}

.footer-section strong {
  color: #ddd;
}

@media screen and (max-width: 900px) {
  .vue-footer-content {
    grid-template-columns: auto 1fr 1fr;
    gap: 30px;
  }
}

@media screen and (max-width: 600px) {
  .vue-footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .footer-logo {
    justify-content: flex-start;
    margin-bottom: 10px;
  }

  .logo-icon {
    width: 48px;
    height: 48px;
  }

  .vue-footer {
    padding: 30px 15px;
    margin-top: 60px;
  }
}
</style>

<script>
export default {
  name: 'VueFooter'
}
</script>
